import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActiveserviceService } from 'src/app/Services/ActiveUsers/activeservice.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExoStar } from 'src/app/models/ExoStar';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { ToastrService } from 'ngx-toastr';

export interface DialogData {
  ExoLicenseKey: ExoStar;
}

@Component({
  selector: 'app-epcs-revoke-dailog',
  templateUrl: './epcs-revoke-dailog.component.html',
  styleUrls: ['./epcs-revoke-dailog.component.css']
})
export class EpcsRevokeDailogComponent implements OnInit {
  epcsRevokeform: FormGroup;
  submitted = false;
  Keys: ExoStar[];
  licensekeydisableBtn: boolean = false;
  public AdminList: IUserDetails[];

  constructor(
    public dialogRef: MatDialogRef<EpcsRevokeDailogComponent>, private formBuilder: FormBuilder, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private activeserviceService: ActiveserviceService, private sharedService: SharedService) {
    
  }

  ngOnInit() {
    this.epcsRevokeform = this.formBuilder.group({
    licensekeys:  ['',],
    epcsadmin:  ['',],
  });
  this.getLicenseKeys();
  this.getAllAdmins()
}
getAllAdmins() {
  this.sharedService.getAllUsersByRole("Admin").subscribe(data => {
    this.AdminList = data;
  });
}
getLicenseKeys() {
  this.activeserviceService.getLicenseKeys().subscribe(result => {
    this.Keys = result;
  });
}
onNoClick(): void {
  this.dialogRef.close();
}

onCancelClick(): void {
  this.dialogRef.close(false);
}

onSubmit() {
  this.dialogRef.close(false);
}
}
